<template>
  <router-link
    class="list-item"
    :to="{ name: 'ticket-by-id', params: { ticketId : item.id } }">
    <div class="item"
         :class="{ '--selector-overlay-pointer' : ( item.id == $route.params.ticketId ) }">
      <span class="">{{ item.subject }}</span>
      <span class="orange">{{ item.status === 'opened' ? $ml.get(`opened`) : $ml.get(`closed`) }}
      </span>
    </div>
  </router-link>

</template>

<script>
  export default {
    name: "TicketItem",
    props: ['item']
  }
</script>

<style lang="scss" scoped>
  .list-item {
    .item {
      padding: 8px 20px;
      color: #2c3e50;
      display: flex;
      justify-content: space-between;
      transition: .3s;
      margin-bottom: 4px;

      span {
        font-weight: bold;
        font-size: 18px;
        z-index: 100;
      }

      .orange {
        text-transform: uppercase;
        font-style: normal;
        font-weight: bold;
        line-height: 12px;
        padding: 5px;
        background: #F2B14E;
        border-radius: 3px;
        display: block;
        font-size: 10px;

        &:not(.sub) {
          font-weight: bold;
          /*font-size: 16px;*/
        }
      }

      &.--selector-overlay-pointer {
        color: #fff;
      }
    }
  }

</style>
